import orderBy from "lodash/orderBy";
import { PER_PAGE_UNPAGINATED } from "PFApp/constants/unpaginated";
import { Stack } from "PFComponents/containers";
import { Divider } from "PFComponents/divider";
import { LoadingDots } from "PFComponents/loading_dots";
import { Modal } from "PFComponents/modal";
import { useProfileSkillsFrameworks } from "PFCore/hooks/queries/skills_frameworks/use_profile_skills_frameworks";
import { CurrentProfile, CustomValue, Profile } from "PFTypes";
import { Fragment, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { SkillsFrameworkRow } from "./skills_framework_row";
import css from "./skills_frameworks_suggested_skills_modal.module.scss";

type SkillsFrameworksSuggestedSkillsModalProps = {
  profile: Profile | CurrentProfile;
  canEditSkills: boolean;
  onSkillRanked?: (customValue: Partial<CustomValue>) => void;
  onClose: VoidFunction;
};

export const SkillsFrameworksSuggestedSkillsModal = ({
  profile,
  canEditSkills,
  onSkillRanked,
  onClose
}: SkillsFrameworksSuggestedSkillsModalProps) => {
  const { t } = useTranslation("profiles", { keyPrefix: "show.parts.skillsModal.suggestions.framework" });

  const { data, isLoading } = useProfileSkillsFrameworks({
    profileId: profile.id,
    params: {
      page: 1,
      perPage: PER_PAGE_UNPAGINATED
    }
  });

  const sortedSkillsFrameworks = useMemo(() => orderBy(data?.entries || [], "name"), [data]);

  return (
    <Modal title={t("title")} onClose={onClose} showOKButton={false} classes={{ modal: css.modal }}>
      <Stack gap="spacingLg" className={css.content}>
        {isLoading && <LoadingDots circlesEnabled circleSize="xs" centered />}
        {sortedSkillsFrameworks.map((skillsFramework, index) => (
          <Fragment key={skillsFramework.id}>
            <SkillsFrameworkRow
              skillsFramework={skillsFramework}
              profile={profile}
              canEditSkills={canEditSkills}
              onSkillRanked={onSkillRanked}
            />
            {index < sortedSkillsFrameworks.length - 1 && <Divider />}
          </Fragment>
        ))}
      </Stack>
    </Modal>
  );
};
